import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';

import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../../hooks/use-app-dispatch';
import { setSelectedPaymentMethod } from '../../../lib/actions';
import { selectState } from '../../../selectors';
import { selectDefaultPaymentMethod, selectPaymentMethodSelectionInfo } from '../../../selectors/account';
import PaymentMethodSelector from './payment-method-selector';

const PaymentSelection = () => {
  const { account } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const { paymentMethods, selectedPaymentMethod } = account;

  const defaultPaymentMethod = useSelector(selectDefaultPaymentMethod);
  const initPaymentMethod = defaultPaymentMethod != null ? defaultPaymentMethod : paymentMethods[0];
  const paymentMethodSelectionInfo = useSelector(selectPaymentMethodSelectionInfo);

  const onSetPaymentMethod = (paymentMethodId: string | null) => dispatch(setSelectedPaymentMethod(paymentMethodId));
  const setDefaultPaymentMethod =
    initPaymentMethod != null ? () => dispatch(setSelectedPaymentMethod(initPaymentMethod.Id)) : undefined;

  return selectedPaymentMethod === null ? (
    <button
      type='button'
      data-ref='buy.payment-selection.submit-button'
      className='link margin-left-md'
      onClick={setDefaultPaymentMethod}
    >
      {t('client.buttons.use-existing-payment-method')}
    </button>
  ) : (
    <SRow>
      <SCol span='lg-8 md-12 6'>
        <PaymentMethodSelector
          paymentMethodSelectionInfo={paymentMethodSelectionInfo}
          onSetPaymentMethod={onSetPaymentMethod}
        />
      </SCol>
    </SRow>
  );
};

export default PaymentSelection;
